import { PopoverPlacement } from "@idui/react-popover";
import {
  Edit as EditIcon,
  Visibility as VisibilityIcon,
} from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { startCase } from "lodash";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { FramerTooltip } from "../../../tooltips";

interface IButtonOpenStation {
  watchedId: number | undefined;
  onClick: () => void;
  tooltipLabelTranslationKey?: string;
  readonlyMode?: boolean;
}

export const ButtonOpenStation: FC<IButtonOpenStation> = ({
  watchedId,
  onClick,
  readonlyMode,
  tooltipLabelTranslationKey,
}) => {
  const { t } = useTranslation();

  const defaultTooltipTranslation = tooltipLabelTranslationKey
    ? startCase(t(tooltipLabelTranslationKey))
    : t("general.MANAGE_ENTITY", { entity: t("station.single") });

  return (
    <FramerTooltip
      content={
        !watchedId
          ? t("ride.PLEASE_CHOOSE_STATION_FIRST")
          : defaultTooltipTranslation
      }
      placement={PopoverPlacement.top}
    >
      {/* Prevent "A disabled element does not fire events." MUI error*/}
      <span>
        <IconButton disabled={!watchedId} onClick={onClick} color="primary">
          {!readonlyMode && <EditIcon />}
          {!!readonlyMode && <VisibilityIcon />}
        </IconButton>
      </span>
    </FramerTooltip>
  );
};
